module.exports = __webpack_public_path__ + "img/bier.71a73e99.png";